import { colorForAnnotation } from "../../../colorScale";

import styles from "./EventPill.module.css";

interface EventPillProps {
  name: string;
  /**
   * The event's custom color (`display_options.color`), if set. Otherwise the
   * color is derived from the name, so the pill matches the event's color
   * elsewhere in the app.
   */
  color?: string;
  onClick: () => void;
}

/**
 * A small, highlighted pill showing an event's name in a panel toolbar. Unlike
 * the `Tag` foundation primitive (a neutral pill with a colored dot), this is a
 * color-filled highlight in the event's own color.
 */
export function EventPill({ name, color, onClick }: EventPillProps) {
  return (
    <button
      type="button"
      className={styles.pill}
      // Colors are per-event, so they are set inline rather than in the CSS module.
      style={{
        backgroundColor: colorForAnnotation(name, 0.25, color),
        borderColor: colorForAnnotation(name, 0.6, color),
      }}
      title={name}
      onClick={onClick}
    >
      {name}
    </button>
  );
}
